export const CacheNames = {
  apiDB: 'apiDB',
  jobs: 'jobs',
};
